import ErrorView from "../../components/ErrorView";
import LoadingView from "../../components/LoadingView";
import NoMatterView from "../../components/NoMatterView";
import { useSpousalSupportOrder } from "../../contexts/SpousalSupportOrderContext";
import { useMatter } from "../../contexts/MatterContext";
import { Table, TableBody } from "../../design/table";
import SpousalSupportOrderListItem from "./components/SpousalSupportOrderListItem";

const SpousalSupportOrdersListPage = () => {
  const { currentMatterId } = useMatter();
  const { spousalSupportOrders, loading, error } = useSpousalSupportOrder();

  if (!currentMatterId) {
    return <NoMatterView />;
  }

  if (loading.list) {
    return <LoadingView title="Loading Spousal Support Orders" />;
  }

  if (error.list) {
    return <ErrorView error={error.list} />;
  }

  return (
    <Table>
      <TableBody>
        {spousalSupportOrders.map((order) => (
          <SpousalSupportOrderListItem
            key={order._id}
            spousalSupportOrder={order}
          />
        ))}
      </TableBody>
    </Table>
  );
};

export default SpousalSupportOrdersListPage;
